import React, {useReducer} from 'react'
import LoginReducer from './LoginReducer'
import logincontext from './LoginContext'
import ClientAxios from '../../config/clientAxios'
import tokenAuth from '../../config/tokenAuth'
// import Swal from 'sweetalert2'
import { LOGIN, USERAUTHCORRECT, CLOSESESSION, 
  // SECONDCONFIRM
} from '../../types'

const LoginState = props => {
  const initialState = {
    counter: false,
    authentication: null,
    errort: false,
    msg: '',
  }
  
  const [state, dispatch] = useReducer(LoginReducer, initialState)

  const authenticateUser = async (nip, nSocio) => {
    
    try {
      
      const response = await ClientAxios.get('/api/login', {params: {nip, nSocio}})
      console.log(response.data)
      dispatch({
        type: LOGIN,
        payload: response
      })
      ReturnAuth()
    } catch (error) {
      console.error(error);
    }
  }

  const ReturnAuth = async () => {
    const token = sessionStorage.getItem('primera')
    
    if (token) { //* si existe token puede authenticar
      await tokenAuth(token) //the token is send to put in the headers
      dispatch({
        type: USERAUTHCORRECT
      })
    }
    
  }

  //! FUNCIONALIDAD EN CONTROLADOR PRINCIAL
  // const secondConfirmation = async () => {
  //   const { value: nip } = await Swal.fire({
  //     title: 'Ingresa tu nip nuevamente',
  //     input: 'password',
  //     inputLabel: 'Nip',      
  //     inputPlaceholder: 'Nip',
  //     inputAttributes: {
  //       maxlength: 4,
  //       autocapitalize: 'off',
  //       autocorrect: 'off',
  //     }
  //   })

    

  //   try {
    
  //     const token  = localStorage.getItem('token')
  //     // if (token) {
  //     //   tokenAuth(token)
  //     //   dispatch({
  //     //     type: USERAUTHCORRECT
  //     //   })
  //     // }
  //     const response = await ClientAxios.post('/api/login', {nip}, {
  //       headers: {
  //         'x-auth-token' : token
  //       }
  //     })

      
      
  //     if (response.data.error) {
  //       Swal.fire({
  //         title: "Error",
  //         text: response.data.msg,
  //         icon: 'error',
  //         confirmButtonText: 'Cool'
  //       })
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
    

  // }

  const CloseSession = () => {
    dispatch({
      type: CLOSESESSION
    })
  }
  
  return (
    <logincontext.Provider
      value={{
        counter: state.counter,
        authentication: state.authentication,
        errort: state.errort,
        msg: state.msg,
        authenticateUser,
        ReturnAuth,
        
        CloseSession
      }}
    >
      {props.children}
    </logincontext.Provider>
  )
}

export default LoginState
